export default __webpack_public_path__ + "static/media/cn.03403229.svg";